import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/whatsapp': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M380.9 97.1C339 55.1 283.2 32 223.9 32 101.5 32 1.9 131.6 1.9 254 1.9 293.1 12.1 331.3 31.5 365L0 480 117.7 449.1C150.1 466.8 186.6 476.1 223.8 476.1H223.9C346.2 476.1 448 376.5 448 254.1 448 194.8 422.8 139.1 380.9 97.1zM223.9 438.7C190.7 438.7 158.2 429.8 129.9 413L123.2 409 53.4 427.3 72 359.2 67.6 352.2C49.1 322.8 39.4 288.9 39.4 254 39.4 152.3 122.2 69.5 224 69.5 273.3 69.5 319.6 88.7 354.4 123.6 389.2 158.5 410.6 204.8 410.5 254.1 410.5 355.9 325.6 438.7 223.9 438.7zM325.1 300.5C319.6 297.7 292.3 284.3 287.2 282.5 282.1 280.6 278.4 279.7 274.7 285.3 271 290.9 260.4 303.3 257.1 307.1 253.9 310.8 250.6 311.3 245.1 308.5 212.5 292.2 191.1 279.4 169.6 242.5 163.9 232.7 175.3 233.4 185.9 212.2 187.7 208.5 186.8 205.3 185.4 202.5 184 199.7 172.9 172.4 168.3 161.3 163.8 150.5 159.2 152 155.8 151.8 152.6 151.6 148.9 151.6 145.2 151.6 141.5 151.6 135.5 153 130.4 158.5 125.3 164.1 111 177.5 111 204.8 111 232.1 130.9 258.5 133.6 262.2 136.4 265.9 172.7 321.9 228.4 346 263.6 361.2 277.4 362.5 295 359.9 305.7 358.3 327.8 346.5 332.4 333.5 337 320.5 337 309.4 335.6 307.1 334.3 304.6 330.6 303.2 325.1 300.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/whatsapp.js
// module id = vIDW
// module chunks = 144